module.exports = __webpack_public_path__ + "static/media/8478f9da.jpg";